import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '../components/Welcome'
import Quiz from '../components/Quiz'
import Result from '../components/Result';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Welcome',
            component: Welcome
        },
        {
            path: '/quiz',
            name: 'Quiz',
            component: Quiz
        },
        {
            path: '/result/:score',
            name: 'Result',
            component: Result,
            props: true
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js